import { FC, Children, useEffect, useState } from 'react';
import { Container, Dimmer, Loader, Segment } from 'semantic-ui-react';
import { List, Button, Message, TableProps as TableImplProps } from 'semantic-ui-react';
import { EfsFile } from '../../api/files';
import { useApi, api } from '../../api/api';
import { SyncButton } from '../../components/buttons';
import Uploader, { UploaderProps } from '../../components/Uploader';
import { envColor } from '../../common';


interface IOProps extends TableImplProps {
    uploader?: FC<UploaderProps>;
}


const FileManager: FC<IOProps> = (props) => {
    const filesApi = useApi(api.files);
    const [events, setEvents] = useState<Array<EfsFile>>([]);
    const [files, setFiles] = useState<Array<File>>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [loaded, setLoaded] = useState(false);

    const load = async (path: string) => {
        return filesApi
            .index(
            path
            )
            .catch(e => console.error(e));
    }

    const call_delete = async (path: string) => {
        return filesApi
            .remove(
            path
            )
            .catch(e => console.error(e));
    }

    const download = async (path: string) => {
        return filesApi
            .read(
            path
            )
            .catch(e => console.error(e));
    }

    const copy = async (current_path:string, s3_path: string) => {
        return filesApi
            .s3Copy(
            current_path, s3_path
            )
            .catch(e => console.error(e));
    }

    const test_load = async (path: string='') => {
        setLoaded(false);
        setLoading(true);
        setError(false);
        const content = await load(path);
        setEvents(content);
        setLoading(false);
        setLoaded(true);
    return content
    }

    const saveFile = async (name:string, path: string) => {
        const newFile = await download(path)
        const content = atob(newFile);

        if (content.startsWith("https")){
            const link = document.createElement('a');
            link.href = content;
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
        }
        else {
        const bytesNums = new Array(content.length);
        for (let i = 0; i < content.length; i++) {
            bytesNums[i] = content.charCodeAt(i);
        }
        const byteArray = new Uint8Array(bytesNums);
        const url = window.URL.createObjectURL(new Blob([byteArray]));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
        }
    };


    const copyFile = async (current_path:string, s3_path: string) => {

        console.log('path on s3 - ', s3_path)
        console.log('current path - ', current_path)

        if (window.confirm(`You are going to copy ${s3_path} to ${current_path} Are You sure?`) == true) {
            await copy(current_path, s3_path)
            test_load(current_path);
        }
        else {
        }

    };

    const delete_file = async (file:EfsFile) => {
        let result;
        if (window.confirm(`You are going to delete ${file.name}. Are You sure?`) == true) {
          let delete_result = await call_delete(file.path);
          let current_page = '/mnt/workspace/'+file.path.split('/').slice(3, -1).join('/')
          test_load(current_page);

          if (delete_result === 403){
            setError(true);
          }
        } else {
          result = "";
        }
    }

    const check_download_visibility = (file:EfsFile) => {
    if (file.type === 'file'){
        return 'visible'
    }
    else{
        return 'hidden'
      }
    }

    const check_copy_visibility = (file:EfsFile) => {
    if (file.type === 's3File'){
        return 'visible'
    }
    else{
        return 'hidden'
      }
    }

    const check_icon = (file:EfsFile) => {
    if (file.type === 's3File'){
        return 'bitbucket'
    }
    else if (file.type === 'dir') {
        return 'folder'
      }
    else {
        return 'file'
    }
    }

    const checkDirectory = (file:EfsFile) => {
    if (file.type === 's3File'){
        return 'S3TemporaryFile'
    }
    else if (file.type === 'dir') {
        return 'Directory'
      }
    else {
        return file.size+' bytes'
    }
    }

    const get_cells = () => {
        const entries = events.entries

        let current_list: EfsFile[] = []

        Object.entries(entries).forEach(([key, value], index) => {
        current_list.push(value)
        });

        current_list = current_list.sort((a, b) => a.name.localeCompare(b.name))
        let previous_page = ''
        let current_page = '/mnt/workspace/'

        if (current_list.length > 0){
        previous_page = '/mnt/workspace/'+current_list[0].path.split('/').slice(3, -2).join('/')
        current_page = '/mnt/workspace/'+current_list[0].path.split('/').slice(3, -1).join('/')
        }

        const rows = Children.toArray(current_list.map(item => (
                  <List.Item
                    onClick={() => (item.type==='dir')? test_load(item.path): null} >
                  <List.Icon name={check_icon(item)} />
                  <List.Content>
                          <Button
                              icon='trash'
                              size='mini'
                              style={{
                               float: 'right',
                               background: 'white',
                               visibility: (item.type!=='s3File')?'visible':'hidden'}}
                              onClick={() => delete_file(item)}
                          ></Button>
                          <Button
                              icon='download'
                              size='mini'
                              style={{visibility: check_download_visibility(item), float: 'right', background: 'white'}}
                              onClick={() => (item.type==='file')? saveFile(item.name, item.path):null}
                          ></Button>
                          <Button
                              icon='copy'
                              size='mini'
                              style={{visibility: check_copy_visibility(item), float: 'right', background: 'white'}}
                              onClick={() => (item.type==='s3File')? copyFile(current_page, item.path):null}
                          ></Button>
                          <List.Description
                          style={{
                          float:'left',
                          }}>
                          {item.mtime}
                         </List.Description>
                         <List.Description
                         style={{
                          float:'center',
                          position: 'absolute',
                          right: '500px',
                          width: '150px',
                          textAlign: 'left'
                          }}>{checkDirectory(item)}
                         </List.Description>
                         <List.Description
                          style={{
                          float:'right',
                          textAlign:'left',
                          fontWeight: 'bold'
                          }}>
                          {item.name}</List.Description>
                  </List.Content>
                  </List.Item>
                )))

        rows.unshift((
                <List.Item onClick={()=>test_load(previous_page)} >
                  <List.Icon name='arrow left' />
                  <List.Content>
                         <List.Header>{current_page}</List.Header>
                  </List.Content>
                  </List.Item>))

        return rows
    };

    useEffect(() => {
      const fetchData = async () => {
        const data = await test_load();
      }
      fetchData()
        .catch(console.error);
    }, [])

    const upload = async (files: File[], path?: string) => {
        if (path) {
            const response = await filesApi.write(path, files);
            if (response !== null){
                test_load(response);
            }
        }
    };

    const render_uploader = (events: EfsFile[]) => {
        const entries = events.entries

        let current_list: EfsFile[] = []

        Object.entries(entries).forEach(([key, value], index) => {
            current_list.push(value)
        });

        let page = ''
        if (current_list.length > 0){
            page = 'temp_download/'+current_list[0].path.split('/').slice(3, -1).join('/')
        }

       return <Uploader onUpload={upload} path={page} />
    }


    return (
    <>

    {error && <Message>
                    <Message.Header>Error</Message.Header>
                    <p>
                      Only Admin users can delete files on EFS.
                    </p>
                  </Message>
    }

        <Container fluid>
        <SyncButton load={test_load} color={envColor} />
            {loaded && render_uploader(events)}
            {loading ?
                <Dimmer inverted active={true}><Loader/></Dimmer> :
                <List selection verticalAlign='middle' divided relaxed>
                    {get_cells()}
                </List>
            }
      </Container>
    </>

    );
};

export default FileManager;
